import styled from "styled-components";

export const SectionContainer = styled.section`
  display: flex !important;
  flex-direction: column;
  background: linear-gradient(90deg, #3b53ff 0%, #40bbff 100%);
  min-height: calc(100vh - 98px);
  justify-content: center;
  align-items: center;
  padding: 0 5%;
`;

export const MainTitle = styled.h1`
  color: #ffffff;
  font-family: Campuni;
  font-size: 2rem;
  font-weight: bold;
  margin-top: 2rem;
  margin-bottom: 1rem;
  max-width: 50%;
  text-align: center;

  @media screen and (max-width: 600px) {
    font-size: 1.875rem;
    margin-bottom: 2.875rem;
    max-width: 100%;
  }
`;
